module.exports = __webpack_public_path__ + "img/green1.d29c546d.svg";